const ContextActions = {
    CLOSE: "*context/close",
};

export default ContextActions;



// WEBPACK FOOTER //
// ./app/data/util/ContextActions.js